import { render, staticRenderFns } from "./UserMian.vue?vue&type=template&id=4f35bd63&scoped=true"
import script from "./UserMian.vue?vue&type=script&lang=js"
export * from "./UserMian.vue?vue&type=script&lang=js"
import style0 from "./UserMian.vue?vue&type=style&index=0&id=4f35bd63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f35bd63",
  null
  
)

export default component.exports